export default {
  QUESTION: 'Question',
  QUESTION_TYPE: 'Type de question',
  EMPTY_OPTIONS: 'Veuillez fournir les valeurs d’une option.',
  FILL_REQUIRED_VALUES: 'Veuillez remplir les valeurs requises.',
  DELETE_QUESTION_POPUP_TITLE: 'Supprimer une question?',
  DELETE_QUESTION_POPUP_LABEL:
    'Une fois supprimée, la question ne sera plus visible dans l’application et devra être ajoutée à nouveau si vous souhaitez la récupérer.',
  FORM_UPDATE_SUCCESS: 'Votre formulaire a été mis à jour avec succès!',
  CHOOSE_ANS_TYPE: 'Choisir un type de réponse',
  SETUP_QUESTION: 'Configurer les questions de qualification',
  SETUP_QUESTION_INFO: 'Modifiez ces questions pour qualifier vos prospects; les changements seront mis à jour dans votre application.',
  FIX_QUESTION_INFO: 'Cette question est obligatoire dans l’application et ne peut pas être éditée ou modifiée.',
  NEW_QUESTION_BTN: 'Cliquez ici pour ajouter une nouvelle question'
}
